// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"BookEquipmentMainPage_pageTitle__y_oKG"};